define.alias("shared/helpers/profile-color-class", "settings/helpers/profile-color-class");